<template>
  <div class="devops-card" @click="toJump">
    <div class="value">{{ value }}</div>
    <div class="name">{{ name }}</div>
  </div>
</template>
<script>
export default {
  name: "devops-card",
  props: {
    name: String,
    value: [String, Number],
    path: String
  },
  setup(props) {
    const toJump = () => {
      if (props.path) {
        // router.push(props.path);
        window.open(props.path, "_blank");
      }
    };
    return {
      toJump
    };
  }
};
</script>
<style scoped lang="less">
.devops-card {
  padding: 16px 0;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  .value {
    color: #1d2129;
    font-size: 18px;
    line-height: 26px;
  }
  .name {
    margin-top: 2px;
    color: #4e5969;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
  }
}
.devops-card:hover {
  background-color: #f7f8fa;
}
</style>
